<template>
  <section>
    <section class="faq">
      <section class="faq_detail_body">
        <!-- <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs> -->
        <div class="faq_page">
          <div class="page">
            <div>
              <h2>Xiaomi Phones (Android 9.0)</h2>
              <h3>Problem</h3>
              <p>
                Not getting notifications for new ToTok messages? Here is the
                fix.
              </p>
              <h3>Causes</h3>
              <p>
                Xiaomi phones system automatically ends all apps running in
                background, unless they are marked as protected apps manually.
              </p>
              <h3>Solution</h3>
              <h4>Enable Notifications</h4>
              <ol>
                <li>Go to your Xiaomi phone's Settings</li>
                <li>Scroll down and tap on Notifications & status bar</li>
                <li>Tap on App notifications</li>
                <li>Find ToTok and tap on it</li>
                <li>Switch on the notification options</li>
              </ol>
              <div class="image" style="flex: border-box;">
                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi1_1.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_1"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi1_2.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_2"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi1_3.jpg"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_3"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi1_4.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_4"
                />
              </div>

              <h4>Set ToTok as Non-restricted App</h4>
              <ol>
                <li>Go to your Xiaomi phone's Settings</li>
                <li>Scroll down and tap on Battery & performance</li>
                <li>Tap on Manage apps battery usage</li>
                <li>Tap on Choose apps</li>
                <li>Find ToTok and tap on it</li>
                <li>Tap on No restrictions</li>
              </ol>
              <div class="image" style="flex: border-box;">
                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi2_1.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_5"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi2_2.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_6"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi2_3.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_7"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi2_4.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_8"
                />
              </div>

              <h4>Enable Autostart</h4>
              <ol>
                <li>Go to your Xiaomi phone's Settings</li>
                <li>Scroll down and tap on Permissions</li>
                <li>Tap on Autostart</li>
                <li>Find ToTok and enable Autostart</li>
              </ol>
              <div class="image" style="flex: border-box;">
                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi3_1.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_9"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi3_2.png"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_10"
                />

                <img
                  class="screen_shot"
                  src="https://static.totok.ai/official/xiaomi3_3.jpg"
                  height="400"
                  width="200"
                  alt="xiaomi_enbalenotification_11"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <Footer style="margin-top: 40px;" v-show="isNew"></Footer>
    <FootBanner v-show="!isPc && !isIOS"></FootBanner>
  </section>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  data() {
    return {};
  },
  computed: {
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
    isNew() {
      let os = this.$route.fullPath.match(/ios|android/);
      if (os && os.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {},

  components: {
    Footer,
    FootBanner,
  },
};
</script>

<style scoped lang="stylus">

@media only screen and (max-width: 700px) {

       .faq_detail_body {
          //  padding-top: 1.1rem;

           .faq_page {
               margin-left: 20px;
               margin-right: 20px;
               margin-bottom: 80px;
               margin-top:30px;


               h2 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 28px;
                   font-weight: 400;
                   color: #222222;
                   -webkit-font-smoothing: antialiased;
                   padding-bottom: 0px;
                  //  padding-top: 40px;
                   margin: 0px;
               }

               h3 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 22px;
                   font-weight: 400;
                   color: #4378f2;
                   padding-top: 23px;
                   padding-bottom: 16px;
                   margin: 0;
               }

               h4 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 20px;
                   font-weight: 400;
                   color: #000000;
                   padding-top: 20px;
                   padding-bottom: 13px;
                   margin: 0;

               }

               h6 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 15px;
                   font-weight: 400;
                   color: #999999;
                   margin-top: 0px;
                   margin-bottom: 10px;
               }

               p {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0px;
                   margin-bottom: 20px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
                   line-height: 22px;
               }
               .info {
                    padding: 0px;
                    margin: 0 auto;
                    font-size: 13px;
                    font-weight: 500;
                    color: #a7a7a7;
                    text-align: left;
                    line-height: 1.6rem;
                }

               ul {
                   list-style: disc;
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0;
                   margin-bottom: 10px;
                   margin-left: 24px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
               }

               ol {
                   list-style: decimal;
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0;
                   margin-bottom: 10px;
                   margin-left: 24px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
               }

               li {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0px;
                   margin-bottom: 10px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
                   line-height: 22px;
                   margin-left: 20px;
                   font-weight:600;
               }

               .header {
                   height: 100px;
                   background: #4378f2;
               }

               .page {
                   max-width: 768px;
                   display: flex;
                   margin-bottom: 100px
               }

               .screen_shot {
                   border-color: #3a8ee6;
                   border-width: 1px;
                   border-style: solid;
                   margin: 20px;
               }
           }

       }

   }

   @media only screen and (min-width: 701px) {
       .faq_detail_body {
           margin: 0 auto;
           width: 800px;

           .faq_page {
               margin-left: 20px;
               margin-right: 20px;
               margin-bottom: 80px;
               margin-top:90px;

               h2 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 28px;
                   font-weight: 400;
                   color: #222222;
                   -webkit-font-smoothing: antialiased;
                   padding-bottom: 0px;
                   padding-top: 40px;
                   margin: 0px;
               }

               h3 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 22px;
                   font-weight: 400;
                   color: #4378f2;
                   padding-top: 23px;
                   padding-bottom: 16px;
                   margin: 0;
               }

               h4 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 20px;
                   font-weight: 400;
                   color: #000000;
                   padding-top: 20px;
                   padding-bottom: 13px;
                   margin: 0;

               }

               h6 {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 15px;
                   font-weight: 400;
                   color: #999999;
                   margin-top: 0px;
                   margin-bottom: 10px;
               }

               p {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0px;
                   margin-bottom: 20px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
                   line-height: 22px;
               }
               .info {
                    padding: 0px;
                    margin: 0 auto;
                    font-size: 13px;
                    font-weight: 500;
                    color: #a7a7a7;
                    text-align: left;
                    line-height: 1.6rem;
                }

               ul {
                   list-style: disc;
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0;
                   margin-bottom: 10px;
                   margin-left: 24px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
               }

               ol {
                   list-style: decimal;
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0;
                   margin-bottom: 10px;
                   margin-left: 24px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
               }

               li {
                   font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                   font-size: 16px;
                   font-weight: normal;
                   margin-top: 0px;
                   margin-bottom: 10px;
                   color: #555555;
                   text-rendering: optimizeLegibility;
                   line-height: 22px;
                   margin-left: 20px;
                    font-weight:600;
               }

               .header {
                   height: 100px;
                   background: #4378f2;
               }

               .page {
                   max-width: 768px;
                   display: flex;
                   margin-bottom: 100px
               }

               .screen_shot {
                   border-color: #3a8ee6;
                   border-width: 1px;
                   border-style: solid;
                   margin: 20px;
               }
           }
       }
   }
</style>
